/**
 * Dorie Atelier — Atelier Offer complimentary gift.
 *
 *   - Gift goal: CA$1,100 after discounts. Other currencies: 1,100 × the
 *     shop-to-active rate (window.Shopify.currency.rate), rounded to a clean
 *     number (nearest 100 below 10,000; then 2 significant figures) — so
 *     USD shows $800.
 *   - The frosted "mystery gift" row in the cart (snippets/cart-products)
 *     shows progress; at the goal it unlocks and a picker opens once with
 *     the two $0 gift products (images swipe; no product-page links).
 *   - Only one gift per order. If the cart falls below the goal the gift is
 *     removed and the mystery row returns.
 *
 * Gift lines = products whose handle starts with "free-gift-".
 * Cart refreshes go through the theme's own `cart:update` event, the same
 * way dorie-cart.js does it.
 */
(function () {
  'use strict';

  if (window.DorieGift) return;

  var GOAL_CAD = 1100;
  var GIFT_HANDLES = ['free-gift-mirror-veil-dupatta', 'free-gift-the-gold-net'];
  var PROMPT_KEY = 'dorieGiftPrompted';
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function api(path, opts) {
    var f = window.__dorieNativeFetch || window.fetch;
    opts = opts || {};
    opts.credentials = 'same-origin';
    opts.headers = Object.assign({ Accept: 'application/json' }, opts.body ? { 'Content-Type': 'application/json' } : {});
    return f(ROOT + path, opts).then(function (r) {
      if (!r.ok) throw new Error(path);
      return r.json();
    });
  }

  function isGift(handle) {
    return typeof handle === 'string' && handle.indexOf('free-gift-') === 0;
  }

  /* Goal in the cart's currency, in cents. */
  function goalCents(currency) {
    if (!currency || currency === 'CAD') return GOAL_CAD * 100;
    var rate = parseFloat(window.Shopify && window.Shopify.currency && window.Shopify.currency.rate);
    if (!rate || rate <= 0) return GOAL_CAD * 100;
    var v = GOAL_CAD * rate;
    var digits = Math.floor(Math.log10(v)) + 1;
    var step = Math.pow(10, Math.max(2, digits - 2));
    return Math.round(v / step) * step * 100;
  }

  function money(cents, currency) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency: currency || 'CAD',
        currencyDisplay: 'narrowSymbol',
        maximumFractionDigits: 0,
      }).format(cents / 100);
    } catch (e) {
      return Math.round(cents / 100) + ' ' + (currency || '');
    }
  }

  function refreshCart(cart) {
    document.dispatchEvent(
      new CustomEvent('cart:update', {
        bubbles: true,
        detail: { resource: cart, sourceId: 'dorie-gift', data: { source: 'dorie-gift', itemCount: cart.item_count } },
      })
    );
  }

  var normaliser = document.createElement('p');

  /* ── Mystery card: paint from the server-rendered data (instant) ── */
  function paint() {
    var cards = document.querySelectorAll('[data-dorie-gift-card]');
    for (var i = 0; i < cards.length; i++) {
      var card = cards[i];
      var total = parseInt(card.getAttribute('data-cart-total'), 10) || 0;
      var cur = card.getAttribute('data-currency') || 'CAD';
      var goal = goalCents(cur);
      var unlocked = total >= goal;
      var msg = card.querySelector('[data-dorie-gift-msg]');
      var fill = card.querySelector('[data-dorie-gift-fill]');
      var btn = card.querySelector('[data-dorie-gift-open]');

      // Only touch the DOM when something actually changed: these nodes sit
      // inside the observed cart, so an unconditional write would re-trigger
      // the observer forever.
      if (card.classList.contains('is-unlocked') !== unlocked) card.classList.toggle('is-unlocked', unlocked);
      var width = Math.min(100, (total / goal) * 100).toFixed(1) + '%';
      if (fill && fill.style.width !== width) fill.style.width = width;
      if (btn && btn.hidden !== !unlocked) btn.hidden = !unlocked;
      if (msg) {
        var html = unlocked
          ? '<strong>Unlocked.</strong> Your gift is waiting'
          : 'You’re <strong>' + money(goal - total, cur) + '</strong> away · free gift at ' + money(goal, cur);
        // Compare against what is really there (a cart re-render resets the
        // text), normalised through the parser so equal markup compares equal.
        normaliser.innerHTML = html;
        if (msg.innerHTML !== normaliser.innerHTML) msg.innerHTML = html;
      }
      autoPrompt(card, unlocked);
    }
    // Drop the mutation records our own writes just produced.
    if (mo) mo.takeRecords();
  }

  /* Open the picker once per unlock, only when the card is on screen. */
  function autoPrompt(card, unlocked) {
    try {
      if (!unlocked) { sessionStorage.removeItem(PROMPT_KEY); return; }
      if (sessionStorage.getItem(PROMPT_KEY)) return;
    } catch (e) { if (!unlocked) return; }
    if (!card.getClientRects().length) return;
    var dlg = card.closest('dialog');
    if (dlg && !dlg.open) return;
    try { sessionStorage.setItem(PROMPT_KEY, '1'); } catch (e) {}
    openPicker();
  }

  /* ── Keep the cart honest: one gift, only at or above the goal ── */
  var syncing = false;
  var syncTimer = null;

  function scheduleSync(delay) {
    clearTimeout(syncTimer);
    syncTimer = setTimeout(sync, delay == null ? 350 : delay);
  }

  function sync() {
    if (syncing) return scheduleSync(400);
    syncing = true;
    api('cart.js')
      .then(function (cart) {
        var gifts = cart.items.filter(function (it) { return isGift(it.handle); });
        if (!gifts.length) return null;
        var goal = goalCents(cart.currency);
        var updates = {};
        var notice = null;
        if (cart.total_price < goal) {
          gifts.forEach(function (it) { updates[it.key] = 0; });
          notice = 'Gift removed: your order is below ' + money(goal, cart.currency);
        } else {
          // Keep the gift chosen first (oldest line = last in cart.items).
          var keep = gifts[gifts.length - 1];
          gifts.forEach(function (it) { if (it !== keep) updates[it.key] = 0; });
          if (keep.quantity > 1) updates[keep.key] = 1;
        }
        if (!Object.keys(updates).length) return null;
        return api('cart/update.js', { method: 'POST', body: JSON.stringify({ updates: updates }) }).then(function (c) {
          refreshCart(c);
          if (notice) toast(notice);
        });
      })
      .catch(function () {})
      .then(function () { syncing = false; });
  }

  /* ── Toast (top layer, so it shows above the open drawer) ── */
  var toastEl = null;
  function toast(text) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'dorie-gift-toast';
      toastEl.setAttribute('role', 'status');
      if ('popover' in toastEl) toastEl.setAttribute('popover', 'manual');
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = text;
    try { if (toastEl.showPopover) { toastEl.hidePopover && toastEl.matches(':popover-open') && toastEl.hidePopover(); toastEl.showPopover(); } } catch (e) {}
    toastEl.classList.add('is-on');
    clearTimeout(toastEl._t);
    toastEl._t = setTimeout(function () {
      toastEl.classList.remove('is-on');
      try { toastEl.hidePopover && toastEl.hidePopover(); } catch (e) {}
    }, 4200);
  }

  /* ── Picker popup ── */
  var picker = null;
  var products = null;
  var swapKey = null;

  function loadProducts() {
    if (products) return Promise.resolve(products);
    return Promise.all(GIFT_HANDLES.map(function (h) { return api('products/' + h + '.js'); })).then(function (list) {
      products = list;
      return list;
    });
  }

  function giftName(title) {
    return String(title || '').replace(/^free gift\s*[-–—:]\s*/i, '');
  }

  function esc(s) {
    return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; });
  }

  function img(src, w) {
    if (!src) return '';
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  function buildPicker() {
    if (picker) return picker;
    picker = document.createElement('dialog');
    picker.className = 'dorie-gp';
    picker.setAttribute('aria-labelledby', 'dorie-gp-title');
    picker.innerHTML =
      '<button type="button" class="dorie-gp__close" aria-label="Close">' +
        '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>' +
      '</button>' +
      '<p class="dorie-gp__eyebrow">You’ve unlocked a free gift</p>' +
      '<h2 class="dorie-gp__title" id="dorie-gp-title">Choose your <em>gift</em></h2>' +
      '<p class="dorie-gp__sub">One complimentary piece with your order</p>' +
      '<div class="dorie-gp__grid" data-gp-grid><p class="dorie-gp__loading">Loading…</p></div>' +
      '<p class="dorie-gp__err" data-gp-err hidden>Could not add the gift. Please try again.</p>';
    document.body.appendChild(picker);
    picker.querySelector('.dorie-gp__close').addEventListener('click', function () { picker.close(); });
    picker.addEventListener('click', function (e) { if (e.target === picker) picker.close(); });
    picker.addEventListener('close', function () { swapKey = null; });
    picker.addEventListener('click', onPickerClick);
    picker.addEventListener('scroll', onGalleryScroll, true);
    return picker;
  }

  function renderPicker(list) {
    var cur = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'CAD';
    var html = list.map(function (p) {
      var v = p.variants && p.variants[0];
      if (!v) return '';
      // product.js already returns prices in the shopper's currency.
      var value = v.compare_at_price || p.compare_at_price || 0;
      var imgs = (p.images || []).slice(0, 8);
      var name = giftName(p.title);
      return (
        '<div class="dorie-gp__card">' +
          '<div class="dorie-gp__gallery" tabindex="0" aria-label="' + esc(name) + ' photos, swipe for more">' +
            imgs.map(function (src, i) {
              return '<img src="' + img(src, 600) + '" alt="' + esc(name) + (i ? ' ' + (i + 1) : '') + '" loading="' + (i ? 'lazy' : 'eager') + '" draggable="false">';
            }).join('') +
          '</div>' +
          (imgs.length > 1
            ? '<div class="dorie-gp__dots" aria-hidden="true">' + imgs.map(function (_, i) { return '<span' + (i ? '' : ' class="is-on"') + '></span>'; }).join('') + '</div>'
            : '') +
          '<p class="dorie-gp__name">' + esc(name) + '</p>' +
          '<p class="dorie-gp__price">' + (value ? '<s>' + money(value, cur) + '</s> ' : '') + '<span>Free</span></p>' +
          '<button type="button" class="dorie-gp__add" data-gp-add="' + v.id + '"' + (v.available === false ? ' disabled' : '') + '>Add to bag</button>' +
        '</div>'
      );
    }).join('');
    picker.querySelector('[data-gp-grid]').innerHTML = html;
  }

  function openPicker(fromSwapKey) {
    buildPicker();
    swapKey = fromSwapKey || null;
    picker.querySelector('[data-gp-err]').hidden = true;
    if (!picker.open) {
      try { picker.showModal(); } catch (e) { picker.setAttribute('open', ''); }
    }
    loadProducts().then(renderPicker).catch(function () {
      picker.querySelector('[data-gp-grid]').innerHTML = '<p class="dorie-gp__loading">Gifts are unavailable right now.</p>';
    });
  }

  function onGalleryScroll(e) {
    var g = e.target;
    if (!g.classList || !g.classList.contains('dorie-gp__gallery')) return;
    var i = Math.round(g.scrollLeft / Math.max(1, g.clientWidth));
    var dots = g.parentNode.querySelectorAll('.dorie-gp__dots span');
    for (var d = 0; d < dots.length; d++) dots[d].classList.toggle('is-on', d === i);
  }

  function onPickerClick(e) {
    var btn = e.target.closest && e.target.closest('[data-gp-add]');
    if (!btn || btn.disabled) return;
    var id = parseInt(btn.getAttribute('data-gp-add'), 10);
    var all = picker.querySelectorAll('[data-gp-add]');
    for (var i = 0; i < all.length; i++) all[i].disabled = true;
    btn.classList.add('is-adding');
    btn.textContent = 'Adding…';

    // Replace any gift already in the cart (Swap, or a second tap).
    api('cart.js')
      .then(function (cart) {
        var updates = {};
        cart.items.forEach(function (it) { if (isGift(it.handle)) updates[it.key] = 0; });
        if (swapKey) updates[swapKey] = 0;
        return Object.keys(updates).length
          ? api('cart/update.js', { method: 'POST', body: JSON.stringify({ updates: updates }) })
          : null;
      })
      .then(function () {
        return api('cart/add.js', {
          method: 'POST',
          body: JSON.stringify({ items: [{ id: id, quantity: 1, properties: { _gift: 'true' } }] }),
        });
      })
      .then(function () { return api('cart.js'); })
      .then(function (cart) {
        refreshCart(cart);
        picker.close();
      })
      .catch(function () {
        picker.querySelector('[data-gp-err]').hidden = false;
        renderPicker(products || []);
      });
  }

  /* ── Wiring ── */
  document.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target : null;
    if (!t) return;
    if (t.closest('[data-dorie-gift-open]')) {
      e.preventDefault();
      openPicker();
      return;
    }
    var swap = t.closest('[data-dorie-gift-swap]');
    if (swap) {
      e.preventDefault();
      openPicker(swap.getAttribute('data-key'));
    }
  });

  var observed = typeof WeakSet === 'function' ? new WeakSet() : null;
  var mo = new MutationObserver(function (records) {
    // Ignore changes inside the gift card's own text/fill (our painting).
    var external = false;
    for (var i = 0; i < records.length; i++) {
      var t = records[i].target;
      var el = t.nodeType === 1 ? t : t.parentElement;
      if (!el || !el.closest('[data-dorie-gift-msg], [data-dorie-gift-fill]')) { external = true; break; }
    }
    if (!external) return;
    paint();
    scheduleSync();
  });

  function observe() {
    var roots = document.querySelectorAll('cart-items-component');
    for (var i = 0; i < roots.length; i++) {
      if (observed && observed.has(roots[i])) continue;
      if (observed) observed.add(roots[i]);
      mo.observe(roots[i], { childList: true, subtree: true, attributes: true, attributeFilter: ['data-cart-total'] });
    }
  }

  function boot() {
    observe();
    paint();
    scheduleSync(600);
    var drawer = document.querySelector('cart-drawer-component');
    if (drawer) drawer.addEventListener('dialog:open', function () { requestAnimationFrame(paint); });
  }

  document.addEventListener('cart:update', function () { observe(); scheduleSync(); });

  window.DorieGift = { paint: paint, sync: sync, open: openPicker, goalCents: goalCents };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
})();
